function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { DateTime as e } from "@easepick/datetime";

var t = /*#__PURE__*/function () {
  function t(e) {
    _classCallCheck(this, t);

    this.picker = void 0;
    this.picker = e;
  }

  _createClass(t, [{
    key: "render",
    value: function render(_t, i) {
      _t || (_t = new e()), _t.setDate(1), _t.setHours(0, 0, 0, 0), "function" == typeof this["get".concat(i, "View")] && this["get".concat(i, "View")](_t);
    }
  }, {
    key: "getContainerView",
    value: function getContainerView(e) {
      this.picker.ui.container.innerHTML = "", this.picker.options.header && this.picker.trigger("render", {
        date: e.clone(),
        view: "Header"
      }), this.picker.trigger("render", {
        date: e.clone(),
        view: "Main"
      }), this.picker.options.autoApply || this.picker.trigger("render", {
        date: e.clone(),
        view: "Footer"
      });
    }
  }, {
    key: "getHeaderView",
    value: function getHeaderView(e) {
      var _t2 = document.createElement("header");

      this.picker.options.header instanceof HTMLElement && _t2.appendChild(this.picker.options.header), "string" == typeof this.picker.options.header && (_t2.innerHTML = this.picker.options.header), this.picker.ui.container.appendChild(_t2), this.picker.trigger("view", {
        target: _t2,
        date: e.clone(),
        view: "Header"
      });
    }
  }, {
    key: "getMainView",
    value: function getMainView(e) {
      var _t3 = document.createElement("main");

      this.picker.ui.container.appendChild(_t3);
      var i = document.createElement("div");
      i.className = "calendars grid-".concat(this.picker.options.grid);

      for (var _t12 = 0; _t12 < this.picker.options.calendars; _t12++) {
        var _n = document.createElement("div");

        _n.className = "calendar", i.appendChild(_n);

        var _s = this.getCalendarHeaderView(e.clone());

        _n.appendChild(_s), this.picker.trigger("view", {
          date: e.clone(),
          view: "CalendarHeader",
          index: _t12,
          target: _s
        });
        var a = this.getCalendarDayNamesView();
        _n.appendChild(a), this.picker.trigger("view", {
          date: e.clone(),
          view: "CalendarDayNames",
          index: _t12,
          target: a
        });
        var o = this.getCalendarDaysView(e.clone());
        _n.appendChild(o), this.picker.trigger("view", {
          date: e.clone(),
          view: "CalendarDays",
          index: _t12,
          target: o
        });
        var r = this.getCalendarFooterView(this.picker.options.lang, e.clone());
        _n.appendChild(r), this.picker.trigger("view", {
          date: e.clone(),
          view: "CalendarFooter",
          index: _t12,
          target: r
        }), this.picker.trigger("view", {
          date: e.clone(),
          view: "CalendarItem",
          index: _t12,
          target: _n
        }), e.add(1, "month");
      }

      _t3.appendChild(i), this.picker.trigger("view", {
        date: e.clone(),
        view: "Calendars",
        target: i
      }), this.picker.trigger("view", {
        date: e.clone(),
        view: "Main",
        target: _t3
      });
    }
  }, {
    key: "getFooterView",
    value: function getFooterView(e) {
      var _t5 = document.createElement("footer"),
          i = document.createElement("div");

      i.className = "footer-buttons";
      var n = document.createElement("button");
      n.className = "cancel-button unit", n.innerHTML = this.picker.options.locale.cancel, i.appendChild(n);
      var s = document.createElement("button");
      s.className = "apply-button unit", s.innerHTML = this.picker.options.locale.apply, s.disabled = !0, i.appendChild(s), _t5.appendChild(i), this.picker.ui.container.appendChild(_t5), this.picker.trigger("view", {
        date: e,
        target: _t5,
        view: "Footer"
      });
    }
  }, {
    key: "getCalendarHeaderView",
    value: function getCalendarHeaderView(e) {
      var _t6 = document.createElement("div");

      _t6.className = "header";
      var i = document.createElement("div");
      i.className = "month-name", i.innerHTML = "<span>".concat(e.toLocaleString(this.picker.options.lang, {
        month: "long"
      }), "</span> ").concat(e.format("YYYY")), _t6.appendChild(i);
      var n = document.createElement("button");
      n.className = "previous-button unit", n.innerHTML = this.picker.options.locale.previousMonth, _t6.appendChild(n);
      var s = document.createElement("button");
      return s.className = "next-button unit", s.innerHTML = this.picker.options.locale.nextMonth, _t6.appendChild(s), _t6;
    }
  }, {
    key: "getCalendarDayNamesView",
    value: function getCalendarDayNamesView() {
      var e = document.createElement("div");
      e.className = "daynames-row";

      for (var _t13 = 1; _t13 <= 7; _t13++) {
        var _i = 3 + this.picker.options.firstDay + _t13,
            _n2 = document.createElement("div");

        _n2.className = "dayname", _n2.innerHTML = new Date(1970, 0, _i, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, {
          weekday: "short"
        }), _n2.title = new Date(1970, 0, _i, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, {
          weekday: "long"
        }), e.appendChild(_n2), this.picker.trigger("view", {
          dayIdx: _i,
          view: "CalendarDayName",
          target: _n2
        });
      }

      return e;
    }
  }, {
    key: "getCalendarDaysView",
    value: function getCalendarDaysView(e) {
      var _t8 = document.createElement("div");

      _t8.className = "days-grid";
      var i = this.calcOffsetDays(e, this.picker.options.firstDay),
          n = 32 - new Date(e.getFullYear(), e.getMonth(), 32).getDate();

      for (var _e = 0; _e < i; _e++) {
        var _e2 = document.createElement("div");

        _e2.className = "offset", _t8.appendChild(_e2);
      }

      for (var _i2 = 1; _i2 <= n; _i2++) {
        e.setDate(_i2);

        var _n3 = this.getCalendarDayView(e);

        _t8.appendChild(_n3), this.picker.trigger("view", {
          date: e,
          view: "CalendarDay",
          target: _n3
        });
      }

      return _t8;
    }
  }, {
    key: "getCalendarDayView",
    value: function getCalendarDayView(_t9) {
      var i = this.picker.options.date ? new e(this.picker.options.date) : null,
          n = new e(),
          s = document.createElement("div");
      return s.className = "day unit", s.innerHTML = _t9.format("D"), s.dataset.time = String(_t9.getTime()), _t9.isSame(n, "day") && s.classList.add("today"), [0, 6].includes(_t9.getDay()) && s.classList.add("weekend"), this.picker.datePicked.length ? this.picker.datePicked[0].isSame(_t9, "day") && s.classList.add("selected") : i && _t9.isSame(i, "day") && s.classList.add("selected"), this.picker.trigger("view", {
        date: _t9,
        view: "CalendarDay",
        target: s
      }), s;
    }
  }, {
    key: "getCalendarFooterView",
    value: function getCalendarFooterView(e, _t10) {
      var i = document.createElement("div");
      return i.className = "footer", i;
    }
  }, {
    key: "calcOffsetDays",
    value: function calcOffsetDays(e, _t11) {
      var i = e.getDay() - _t11;

      return i < 0 && (i += 7), i;
    }
  }]);

  return t;
}();

var i = /*#__PURE__*/function () {
  function i(e) {
    _classCallCheck(this, i);

    this.picker = void 0;
    this.instances = {};
    this.picker = e;
  }

  _createClass(i, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;

      var e = [];
      this.picker.options.plugins.forEach(function (t) {
        "function" == typeof t ? e.push(new t()) : "string" == typeof t && "undefined" != typeof easepick && Object.prototype.hasOwnProperty.call(easepick, t) ? e.push(new easepick[t]()) : console.warn("easepick: ".concat(t, " not found."));
      }), e.sort(function (e, t) {
        return e.priority > t.priority ? -1 : e.priority < t.priority || e.dependencies.length > t.dependencies.length ? 1 : e.dependencies.length < t.dependencies.length ? -1 : 0;
      }), e.forEach(function (e) {
        e.attach(_this.picker), _this.instances[e.getName()] = e;
      });
    }
  }, {
    key: "getInstance",
    value: function getInstance(e) {
      return this.instances[e];
    }
  }, {
    key: "addInstance",
    value: function addInstance(e) {
      if (Object.prototype.hasOwnProperty.call(this.instances, e)) console.warn("easepick: ".concat(e, " already added."));else {
        if ("undefined" != typeof easepick && Object.prototype.hasOwnProperty.call(easepick, e)) {
          var _t14 = new easepick[e]();

          return _t14.attach(this.picker), this.instances[_t14.getName()] = _t14, _t14;
        }

        if ("undefined" !== this.getPluginFn(e)) {
          var _t15 = new (this.getPluginFn(e))();

          return _t15.attach(this.picker), this.instances[_t15.getName()] = _t15, _t15;
        }

        console.warn("easepick: ".concat(e, " not found."));
      }
      return null;
    }
  }, {
    key: "removeInstance",
    value: function removeInstance(e) {
      return e in this.instances && this.instances[e].detach(), delete this.instances[e];
    }
  }, {
    key: "reloadInstance",
    value: function reloadInstance(e) {
      return this.removeInstance(e), this.addInstance(e);
    }
  }, {
    key: "getPluginFn",
    value: function getPluginFn(e) {
      return _toConsumableArray(this.picker.options.plugins).filter(function (t) {
        return "function" == typeof t && new t().getName() === e;
      }).shift();
    }
  }]);

  return i;
}();

var n = /*#__PURE__*/function () {
  function n(e) {
    _classCallCheck(this, n);

    this.Calendar = new t(this);
    this.PluginManager = new i(this);
    this.calendars = [];
    this.datePicked = [];
    this.cssLoaded = 0;
    this.binds = {
      hidePicker: this.hidePicker.bind(this),
      show: this.show.bind(this)
    };
    this.options = {
      doc: document,
      css: [],
      element: null,
      firstDay: 1,
      grid: 1,
      calendars: 1,
      lang: "en-US",
      date: null,
      format: "YYYY-MM-DD",
      readonly: !0,
      autoApply: !0,
      header: !1,
      inline: !1,
      scrollToDate: !0,
      locale: {
        nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>',
        previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>',
        cancel: "Cancel",
        apply: "Apply"
      },
      documentClick: this.binds.hidePicker,
      plugins: []
    };
    this.ui = {
      container: null,
      shadowRoot: null,
      wrapper: null
    };
    this.version = "1.2.0";

    var _t16 = _objectSpread(_objectSpread({}, this.options.locale), e.locale);

    this.options = _objectSpread(_objectSpread({}, this.options), e), this.options.locale = _t16, this.handleOptions(), this.ui.wrapper = document.createElement("span"), this.ui.wrapper.style.display = "none", this.ui.wrapper.style.position = "absolute", this.ui.wrapper.style.pointerEvents = "none", this.ui.wrapper.className = "easepick-wrapper", this.ui.wrapper.attachShadow({
      mode: "open"
    }), this.ui.shadowRoot = this.ui.wrapper.shadowRoot, this.ui.container = document.createElement("div"), this.ui.container.className = "container", this.options.zIndex && (this.ui.container.style.zIndex = String(this.options.zIndex)), this.options.inline && (this.ui.wrapper.style.position = "relative", this.ui.container.classList.add("inline")), this.ui.shadowRoot.appendChild(this.ui.container), this.options.element.after(this.ui.wrapper), this.handleCSS(), this.options.element.addEventListener("click", this.binds.show), this.on("view", this.onView.bind(this)), this.on("render", this.onRender.bind(this)), this.PluginManager.initialize(), this.parseValues(), "function" == typeof this.options.setup && this.options.setup(this), this.on("click", this.onClick.bind(this));

    var _i3 = this.options.scrollToDate ? this.getDate() : null;

    this.renderAll(_i3);
  }

  _createClass(n, [{
    key: "on",
    value: function on(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.ui.container.addEventListener(e, t, i);
    }
  }, {
    key: "off",
    value: function off(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.ui.container.removeEventListener(e, t, i);
    }
  }, {
    key: "trigger",
    value: function trigger(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.ui.container.dispatchEvent(new CustomEvent(e, {
        detail: t
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      this.options.element.removeEventListener("click", this.binds.show), "function" == typeof this.options.documentClick && document.removeEventListener("click", this.options.documentClick, !0), Object.keys(this.PluginManager.instances).forEach(function (e) {
        _this2.PluginManager.removeInstance(e);
      }), this.ui.wrapper.remove();
    }
  }, {
    key: "onRender",
    value: function onRender(e) {
      var _e$detail = e.detail,
          t = _e$detail.view,
          i = _e$detail.date;
      this.Calendar.render(i, t);
    }
  }, {
    key: "onView",
    value: function onView(e) {
      var _e$detail2 = e.detail,
          t = _e$detail2.view,
          i = _e$detail2.target;

      if ("Footer" === t && this.datePicked.length) {
        i.querySelector(".apply-button").disabled = !1;
      }
    }
  }, {
    key: "onClickHeaderButton",
    value: function onClickHeaderButton(e) {
      this.isCalendarHeaderButton(e) && (e.classList.contains("next-button") ? this.calendars[0].add(1, "month") : this.calendars[0].subtract(1, "month"), this.renderAll(this.calendars[0]));
    }
  }, {
    key: "onClickCalendarDay",
    value: function onClickCalendarDay(t) {
      if (this.isCalendarDay(t)) {
        var _i4 = new e(t.dataset.time);

        this.options.autoApply ? (this.setDate(_i4), this.trigger("select", {
          date: this.getDate()
        }), this.hide()) : (this.datePicked[0] = _i4, this.trigger("preselect", {
          date: this.getDate()
        }), this.renderAll());
      }
    }
  }, {
    key: "onClickApplyButton",
    value: function onClickApplyButton(e) {
      if (this.isApplyButton(e)) {
        if (this.datePicked[0] instanceof Date) {
          var _e3 = this.datePicked[0].clone();

          this.setDate(_e3);
        }

        this.hide(), this.trigger("select", {
          date: this.getDate()
        });
      }
    }
  }, {
    key: "onClickCancelButton",
    value: function onClickCancelButton(e) {
      this.isCancelButton(e) && this.hide();
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      var t = e.target;

      if (t instanceof HTMLElement) {
        var _e4 = t.closest(".unit");

        if (!(_e4 instanceof HTMLElement)) return;
        this.onClickHeaderButton(_e4), this.onClickCalendarDay(_e4), this.onClickApplyButton(_e4), this.onClickCancelButton(_e4);
      }
    }
  }, {
    key: "isShown",
    value: function isShown() {
      return this.ui.container.classList.contains("inline") || this.ui.container.classList.contains("show");
    }
  }, {
    key: "show",
    value: function show(e) {
      if (this.isShown()) return;

      var t = e && "target" in e ? e.target : this.options.element,
          _this$adjustPosition = this.adjustPosition(t),
          i = _this$adjustPosition.top,
          _n4 = _this$adjustPosition.left;

      this.ui.container.style.top = "".concat(i, "px"), this.ui.container.style.left = "".concat(_n4, "px"), this.ui.container.classList.add("show"), this.trigger("show", {
        target: t
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.ui.container.classList.remove("show"), this.datePicked.length = 0, this.renderAll(), this.trigger("hide");
    }
  }, {
    key: "setDate",
    value: function setDate(t) {
      var i = new e(t, this.options.format);
      this.options.date = i.clone(), this.updateValues(), this.calendars.length && this.renderAll();
    }
  }, {
    key: "getDate",
    value: function getDate() {
      return this.options.date instanceof e ? this.options.date.clone() : null;
    }
  }, {
    key: "parseValues",
    value: function parseValues() {
      this.options.date ? this.setDate(this.options.date) : this.options.element instanceof HTMLInputElement && this.options.element.value.length && this.setDate(this.options.element.value), this.options.date instanceof Date || (this.options.date = null);
    }
  }, {
    key: "updateValues",
    value: function updateValues() {
      var e = this.getDate(),
          t = e instanceof Date ? e.format(this.options.format, this.options.lang) : "",
          i = this.options.element;
      i instanceof HTMLInputElement ? i.value = t : i instanceof HTMLElement && (i.innerText = t);
    }
  }, {
    key: "hidePicker",
    value: function hidePicker(e) {
      var t = e.target,
          i = null;
      t.shadowRoot && (t = e.composedPath()[0], i = t.getRootNode().host), this.isShown() && i !== this.ui.wrapper && t !== this.options.element && this.hide();
    }
  }, {
    key: "renderAll",
    value: function renderAll(e) {
      this.trigger("render", {
        view: "Container",
        date: (e || this.calendars[0]).clone()
      });
    }
  }, {
    key: "isCalendarHeaderButton",
    value: function isCalendarHeaderButton(e) {
      return ["previous-button", "next-button"].some(function (t) {
        return e.classList.contains(t);
      });
    }
  }, {
    key: "isCalendarDay",
    value: function isCalendarDay(e) {
      return e.classList.contains("day");
    }
  }, {
    key: "isApplyButton",
    value: function isApplyButton(e) {
      return e.classList.contains("apply-button");
    }
  }, {
    key: "isCancelButton",
    value: function isCancelButton(e) {
      return e.classList.contains("cancel-button");
    }
  }, {
    key: "gotoDate",
    value: function gotoDate(t) {
      var i = new e(t, this.options.format);
      i.setDate(1), this.calendars[0] = i.clone(), this.renderAll();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.options.date = null, this.datePicked.length = 0, this.updateValues(), this.renderAll(), this.trigger("clear");
    }
  }, {
    key: "handleOptions",
    value: function handleOptions() {
      this.options.element instanceof HTMLElement || (this.options.element = this.options.doc.querySelector(this.options.element)), "function" == typeof this.options.documentClick && document.addEventListener("click", this.options.documentClick, !0), this.options.element instanceof HTMLInputElement && (this.options.element.readOnly = this.options.readonly), this.options.date ? this.calendars[0] = new e(this.options.date, this.options.format) : this.calendars[0] = new e();
    }
  }, {
    key: "handleCSS",
    value: function handleCSS() {
      var _this3 = this;

      if (Array.isArray(this.options.css)) this.options.css.forEach(function (e) {
        var t = document.createElement("link");
        t.href = e, t.rel = "stylesheet";

        var i = function i() {
          _this3.cssLoaded++, _this3.cssLoaded === _this3.options.css.length && (_this3.ui.wrapper.style.display = "");
        };

        t.addEventListener("load", i), t.addEventListener("error", i), _this3.ui.shadowRoot.append(t);
      });else if ("string" == typeof this.options.css) {
        var _e5 = document.createElement("style"),
            _t17 = document.createTextNode(this.options.css);

        _e5.appendChild(_t17), this.ui.shadowRoot.append(_e5), this.ui.wrapper.style.display = "";
      } else "function" == typeof this.options.css && (this.options.css.call(this, this), this.ui.wrapper.style.display = "");
    }
  }, {
    key: "adjustPosition",
    value: function adjustPosition(e) {
      var t = e.getBoundingClientRect(),
          i = this.ui.wrapper.getBoundingClientRect();
      this.ui.container.classList.add("calc");

      var _n5 = this.ui.container.getBoundingClientRect();

      this.ui.container.classList.remove("calc");
      var s = t.bottom - i.bottom,
          a = t.left - i.left;
      return "undefined" != typeof window && (window.innerHeight < s + _n5.height && s - _n5.height >= 0 && (s = t.top - i.top - _n5.height), window.innerWidth < a + _n5.width && t.right - _n5.width >= 0 && (a = t.right - i.right - _n5.width)), {
        left: a,
        top: s
      };
    }
  }]);

  return n;
}();

var s = Object.freeze({
  __proto__: null,
  Core: n,
  create: n
});
export { n as Core, n as create, s as easepick };